import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEEMEMBERROLE_LOAD,
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID,
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID,
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID,

    ACTION_COMMITTEEMEMBERROLE_SAVE,

    ACTION_COMMITTEEMEMBERROLE_CREATE,

    ACTION_COMMITTEEMEMBERROLE_VALIDATE,

    ICommitteeMemberRoleLoadAction,
    ICommitteeMemberRoleLoadByIdAction,
    ICommitteeMemberRoleLoadByCommitteeIdAction,
    ICommitteeMemberRolesLoadByPersonnelIdAction,
    ICommitteeMemberRoleLoadFailureAction,
    ICommitteeMemberRoleLoadSuccessAction,

    ICommitteeMemberRoleSaveAction,
    ICommitteeMemberRoleSaveSuccessAction,
    ICommitteeMemberRoleSaveFailureAction,

    ICommitteeMemberRoleCreateAction,
    ICommitteeMemberRoleCreateSuccessAction,
    ICommitteeMemberRoleCreateFailureAction,

    ICommitteeMemberRoleValidateAction,
    ICommitteeMemberRoleValidateSuccessAction,
    ICommitteeMemberRoleValidateFailureAction,

    LoadSuccess,
    LoadFailure,


    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committeeMemberRole";
import { committeeMemberRolesApi } from "../services/committeeMemberRoles";


export const
    getCommitteeMemberRolesEpic = (action$): Observable<ICommitteeMemberRoleLoadSuccessAction | ICommitteeMemberRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_LOAD)
            .mergeMap((action: ICommitteeMemberRoleLoadAction) => {
                return committeeMemberRolesApi
                    .getCommitteeMemberRoles(action.committeeId, action.committeeMemberId)
                    .map(response =>
                        LoadSuccess(response.committeeMemberRoles, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMemberRolesByIdEpic = (action$): Observable<ICommitteeMemberRoleLoadSuccessAction | ICommitteeMemberRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID)
            .mergeMap((action: ICommitteeMemberRoleLoadByIdAction) => {
                return committeeMemberRolesApi
                    .getCommitteeMemberRoleById(action.id)
                    .map(response =>
                        LoadSuccess(response.committeeMemberRole, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMemberRolesByCommitteeIdEpic = (action$): Observable<ICommitteeMemberRoleLoadSuccessAction | ICommitteeMemberRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID)
            .mergeMap((action: ICommitteeMemberRoleLoadByCommitteeIdAction) => {
                return committeeMemberRolesApi
                    .getCommitteeMemberRoleByCommitteeId(action.committeeId, action.committeeMemberId)
                    .map(response =>
                        LoadSuccess(response.committeeMemberRole, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeMemberRolesByPersonnelIdEpic = (action$): Observable<ICommitteeMemberRoleLoadSuccessAction | ICommitteeMemberRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID)
            .mergeMap((action: ICommitteeMemberRolesLoadByPersonnelIdAction) => {
                return committeeMemberRolesApi
                    .getCommitteeMemberRolesByPersonnelId(action.personnelId)
                    .map(response =>
                        LoadSuccess(response.committeeMemberRoles, undefined, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeMemberRoleEpic = (action$): Observable<ICommitteeMemberRoleSaveSuccessAction | ICommitteeMemberRoleSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_SAVE)
            .mergeMap((action: ICommitteeMemberRoleSaveAction) => {
                return committeeMemberRolesApi
                    .setCommitteeMemberRole(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committeeMemberRole, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeMemberRoleEpic = (action$): Observable<ICommitteeMemberRoleCreateSuccessAction | ICommitteeMemberRoleCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_CREATE)
            .mergeMap((action: ICommitteeMemberRoleCreateAction) => {
                return committeeMemberRolesApi
                    .createCommitteeMemberRole(action.committeeId, action.committeeMemberId)
                    .map(response =>
                        CreateSuccess(response.committeeMemberRole, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeMemberRoleEpic = (action$): Observable<ICommitteeMemberRoleValidateSuccessAction | ICommitteeMemberRoleValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEMEMBERROLE_VALIDATE)
            .mergeMap((action: ICommitteeMemberRoleValidateAction) => {
                return committeeMemberRolesApi
                    .validateCommitteeMemberRole(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committeeMemberRole, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }